import React, { useState, useRef, useEffect } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import * as TerminalAppService from "./services/data/TerminalAppService";
import * as TerminalService from "./services/data/TerminalService";
import useMqttClient from "./hooks/useMqttClient";
import ScaleSpinnerProgressSection from "./components/ScaleSpinnerProgressSection";
import Dialog from "./components/Dialog";
import useScreenType from "./hooks/useScreenType";
import toast from "react-hot-toast";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";

const STATE_ENABLED = 1;
const STATE_DISABLED = 0;

const W = "W";
const H = "H";
const QUALITY = "QUALITY";
const ROTATION = "ROTATION";

const BRIGHTNESS = "BRIGHTNESS";
const X = "X";
const Y = "Y";
const SIZE_X = "SIZE_X";
const SIZE_Y = "SIZE_Y";

function PageCameraTest() {
  const screenType = useScreenType();
  const { terminalSettingsState, axiosTerminalAppInstance, instance, getUid } = useFormCtx();

  const [isVisible, setVisible] = useState(true);
  const { isConnected, messages, publish, lastMessage } = useMqttClient(Const.TERMINAL_APP_SERVICE_WEB_SOCKET_URL, Const.TOPIC_MQTTT_LOCAL);
  const [lastProcessedMessage, setLastProcessedMessage] = useState(null);
  const [isMultiplierEnabled, setMultiplierEnabled] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const [image, setImage] = useState(null);

  const [isOnW, setOnW] = useState(false);
  const [isOnH, setOnH] = useState(false);
  const [isOnQ, setOnQ] = useState(false);
  const [isOnB, setOnB] = useState(false);
  const [isOnX, setOnX] = useState(false);
  const [isOnY, setOnY] = useState(false);
  const [isOnSX, setOnSX] = useState(false);
  const [isOnSY, setOnSY] = useState(false);

  const [imageW, setImageW] = useState();
  const [imageH, setImageH] = useState();
  const [imageQuality, setImageQuality] = useState();
  const [imageRotation, setImageRotation] = useState();

  const [imageBrightness, setImageBrightness] = useState(0);
  const [imageX, setImageX] = useState(0);
  const [imageY, setImageY] = useState(0);
  const [imageSizeX, setImageSizeX] = useState(0);
  const [imageSizeY, setImageSizeY] = useState(0);

  const mimeType = "image/jpeg";
  const dataUri = `data:${mimeType};base64,${image}`;

  useEffect(() => {
    function scopedLoadData() {
      initStateAfterCaptureOrError();
    }

    scopedLoadData();

    //cleanup before unload - pri opusteni page insert zakazu card reader
    return () => {
      console.log("PageCardInsert - before unload");
      setCardReaderTo(STATE_DISABLED);
    };
  }, []);

  //volat jen kdyz se zmeni  lastMessage a je zarovne proveden onload
  useEffect(() => {
    if (lastMessage) {
      //zavolam to abych stanovil state
      handleMqttMessage(lastMessage);
    }
  }, [lastMessage]);

  useEffect(() => {
    //naplni data po te co hodntota cameraImageWidth je ruzna od 0
    if (terminalSettingsState.cameraImageWidth != 0) {
      //zavolam to abych stanovil state
      setImageW(terminalSettingsState.cameraImageWidth);
      setImageH(terminalSettingsState.cameraImageHeight);
      setImageQuality(terminalSettingsState.cameraPreviewQuality);
      setImageRotation(terminalSettingsState.cameraImageRotation);

      setImageBrightness(terminalSettingsState.cameraImageBrightnessF);
      setImageX(terminalSettingsState.cameraImageCropX);
      setImageY(terminalSettingsState.cameraImageCropY);
      setImageSizeX(terminalSettingsState.cameraImageCropPercentX);
      setImageSizeY(terminalSettingsState.cameraImageCropPercentY);
    }
  }, [terminalSettingsState.cameraImageWidth]); //zavislost nastavim na hodnotu ktera musi byt vzdy ruzna od 0

  async function initStateAfterCaptureOrError() {
    await setCardReaderTo(STATE_ENABLED);
  }

  const showHideButtonsText = isVisible ? "Schovat tlačítka" : "Zobrazit tlačítka";
  const bottomGridCss = isVisible ? "grid-cols-3" : "grid-cols-1";

  async function getPhoto() {
    console.log(new Date().toISOString(), "getPhoto() from rpi");
    //send(ACTION_GET_PHOTO);

    try {
      setIsLoading(true);
      let { data } = await TerminalAppService.getPhoto(axiosTerminalAppInstance);
      //console.log(data);

      if (!data.isError) {
        console.log("zobrazuji obrazek z card readeru");
        setImage(data?.data?.image);
        //registerPatient(data.data.image, false);
      } else {
        const e = "Chyba při načítání obrázku fotografie";
        console.log(e, data.message);
        setError(e);
      }
    } catch (ex) {
      const e = "Chyba při načítání obrázku fotografie";
      console.log(e, ex);
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }

  async function runCapture() {
    try {
      setIsLoading(true);
      const isError = await setCameraOptions();

      if (!isError) {
        console.log("Start runCapture after setting actual cemera options");
        let { data } = await TerminalAppService.runCapture(axiosTerminalAppInstance);
        if (!data.isError) {
          console.log("Start test photo capture");
        } else {
          const e = "Chyba při focení TEST FOTO";
          console.log(e, data.message);
          setError(e);
        }
      }
    } catch (ex) {
      const e = "Chyba při focení TEST FOTO";
      console.log(e, ex);
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }

  async function postCameraOptionsToApi() {
    try {
      setIsLoading(true);
      const options = {
        cameraImageWidth: imageW,
        cameraImageHeight: imageH,
        cameraPreviewQuality: imageQuality,
        cameraImageRotation: imageRotation,
        cameraImageBrightnessF: imageBrightness,
        cameraImageCropX: imageX,
        cameraImageCropY: imageY,
        cameraImageCropPercentX: imageSizeX,
        cameraImageCropPercentY: imageSizeY,
      };
      await TerminalService.setPhotoOption(instance, getUid(), options);
      console.log("API Camera options updated");
      toast.success("Údaje úspěšně uloženy do API");
    } catch (ex) {
      const e = "Chyba při ukládání parametrů kamery do API";
      console.log(e, ex);
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }

  async function setCameraOptions() {
    const isError = false;
    try {
      const options = {
        w: imageW,
        h: imageH,
        q: imageQuality,
        r: imageRotation,
        b: imageBrightness,
        x: imageX,
        y: imageY,
        sx: imageSizeX,
        sy: imageSizeY,
      };
      let { data } = await TerminalAppService.setCameraOptions(axiosTerminalAppInstance, options);
      if (!data.isError) {
        console.log("Update camera options");
      } else {
        const e = "Chyba při nastavení parametrů kamery do Rpi OS";
        console.log(e, data.message);
        setError(e);
        isError = true;
      }
    } catch (ex) {
      const e = "Chyba při nastavení parametrů kamery do Rpi OS";
      console.log(e, ex);
      setError(e);
      isError = true;
    }
    return isError;
  }

  async function setCardReaderTo(state) {
    try {
      let { data } = await TerminalAppService.setCardReaderTo(axiosTerminalAppInstance, state);
      if (!data.isError) {
        console.log("card reader set to:", state);
      } else {
        const e = "Chyba při nastavení Card reader";
        console.log(e, data.message);
        setError(e);
      }
    } catch (ex) {
      const e = "Chyba při nastavení Card reader";
      console.log(e, ex);
      setError(e);
    }
  }

  async function handleMqttMessage(newMessage) {
    //console.log("handleMqttMessage", newMessage, lastProcessedMessage);

    //nezpracovavat stejnou message vicekrat
    if (lastProcessedMessage !== newMessage) {
      setLastProcessedMessage(newMessage);
      console.log(new Date().toISOString(), "handleMqttMessage", newMessage);

      // Speciální logika pro téma RPi
      if (newMessage?.topic === Const.TOPIC_MQTTT_LOCAL) {
        if (newMessage.payload === Const.LOCAL_MESSAGE_PHOTO_CREATED) {
          getPhoto();
        } else if (newMessage.payload === Const.LOCAL_MESSAGE_PHOTO_ERROR) {
          //send(ACTION_ERROR);
          initStateAfterCaptureOrError();
          console.log("Chyba pri foceni");
        }
      }
    }
  }

  function getVal(val, max) {
    let retVal = val;
    if (val > max) {
      retVal = max;
    } else if (val < 0) {
      retVal = 0;
    }
    // console.log(val, max, retVal);

    return retVal;
  }

  function plus(what) {
    //console.log("plus", what);
    switch (what) {
      case W:
        setImageW(getVal(imageW + (isOnW ? 10 : 1), 850));
        break;
      case H:
        setImageH(getVal(imageH + (isOnH ? 10 : 1), 550));
        break;
      case ROTATION:
        setImageRotation(getVal(imageRotation + 90, 270));
        break;
      case BRIGHTNESS:
        setImageBrightness(getVal(+(imageBrightness + (isOnB ? 0.1 : 0.01)).toFixed(2), 1));
        break;
      case QUALITY:
        setImageQuality(getVal(imageQuality + (isOnQ ? 10 : 1), 100));
        break;
      case X:
        setImageX(getVal(+(imageX + (isOnX ? 0.1 : 0.01)).toFixed(2), 1));
        break;
      case Y:
        setImageY(getVal(+(imageY + (isOnY ? 0.1 : 0.01)).toFixed(2), 1));
        break;
      case SIZE_X:
        setImageSizeX(getVal(+(imageSizeX + (isOnSX ? 0.1 : 0.01)).toFixed(2), 1));
        break;
      case SIZE_Y:
        setImageSizeY(getVal(+(imageSizeY + (isOnSY ? 0.1 : 0.01)).toFixed(2), 1));
        break;
    }
  }

  function minus(what) {
    //console.log("minus", what);

    switch (what) {
      case W:
        setImageW(getVal(imageW - (isOnW ? 10 : 1), 850));
        break;
      case H:
        setImageH(getVal(imageH - (isOnH ? 10 : 1), 550));
        break;
      case ROTATION:
        setImageRotation(getVal(imageRotation - 90, 270));
        break;
      case BRIGHTNESS:
        setImageBrightness(getVal(+(imageBrightness - (isOnB ? 0.1 : 0.01)).toFixed(2), 1));
        break;
      case QUALITY:
        setImageQuality(getVal(imageQuality - (isOnQ ? 10 : 1), 100));
        break;
      case X:
        setImageX(getVal(+(imageX - (isOnX ? 0.1 : 0.01)).toFixed(2), 1));
        break;
      case Y:
        setImageY(getVal(+(imageY - (isOnY ? 0.1 : 0.01)).toFixed(2), 1));
        break;
      case SIZE_X:
        setImageSizeX(getVal(+(imageSizeX - (isOnSX ? 0.1 : 0.01)).toFixed(2), 1));
        break;
      case SIZE_Y:
        setImageSizeY(getVal(+(imageSizeY - (isOnSY ? 0.1 : 0.01)).toFixed(2), 1));
        break;
    }
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "top-div":
          css = "mt-2";
          break;
        case "block-div":
          css = "mb-0";
          break;
        case "title":
          css = "text-sm";
          break;
        case "pm-btn":
          css = "h-12 w-12 text-xl mr-2";
          break;
        case "toggle-btn":
          css = "h-12 w-12 text-base";
          break;
        case "toggle-btn-right":
          css = "h-12 w-12 text-base mr-2";
          break;
        case "bottom-btn":
          css = "h-12 text-base min-w-60";
          break;
        case "bottom-btn-grid":
          css = "bottom-2";
          break;
        case "btn-text-left":
          css = "text-xl mr-2 min-w-12 mb-1";
          break;
        case "btn-text-right":
          css = "text-xl ml-2 min-w-12";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "top-div":
          css = "mt-4";
          break;
        case "block-div":
          css = "mb-3";
          break;
        case "title":
          css = "text-lg";
          break;
        case "pm-btn":
          css = "h-[62px] w-[62px] text-3xl mr-4";
          break;
        case "toggle-btn":
          css = "h-[62px] w-[62px] text-xl";
          break;
        case "toggle-btn-right":
          css = "h-[62px] w-[62px] text-xl mr-4";
          break;
        case "bottom-btn":
          css = "h-[62px]  text-xl min-w-80";
          break;
        case "bottom-btn-grid":
          css = "bottom-4";
          break;
        case "btn-text-left":
          css = "text-3xl mr-4 min-w-16 mb-1";
          break;
        case "btn-text-right":
          css = "text-3xl ml-4 min-w-16";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "top-div":
          css = "mt-4";
          break;
        case "block-div":
          css = "mb-4";
          break;
        case "title":
          css = "text-2xl";
          break;
        case "pm-btn":
          css = "h-16 w-16 text-3xl mr-4";
          break;
        case "toggle-btn":
          css = "h-16 w-16 text-xl";
          break;
        case "toggle-btn-right":
          css = "h-16 w-16 text-xl mr-4";
          break;
        case "bottom-btn":
          css = "h-20 text-xl min-w-80";
          break;
        case "bottom-btn-grid":
          css = "bottom-4";
          break;
        case "btn-text-left":
          css = "text-3xl mr-4 min-w-16 mb-1";
          break;
        case "btn-text-right":
          css = "text-3xl ml-4 min-w-16";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  const showImage = image && !error && !isLoading;
  const showButtons = isVisible && !error && !isLoading;
  const showHideButton = !error && !isLoading;

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  return (
    <>
      <Navbar customTitle={"Nastavení parametrů kamery"} />
      {isLoading && <ScaleSpinnerProgressSection />}
      {error && <Dialog buttonText="Zavřít" type="error" title={"Chyba při zpracování požadavku"} message={error} onClick={() => setError("")} />}

      <div className={`${getCssFor("top-div")} mx-0`}>
        <div className="bg-accenta absolute top-28 left-1/2 text-center text-primary z-0">
          {showImage && (
            <img
              // Atribut src obsahuje kompletní Data URI
              src={dataUri}
              alt="Base64 zakódovaný obrázek"
              className="-translate-x-1/2"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          )}
        </div>

        {showButtons && (
          <div className="absolute grid grid-cols-2 px-4 w-full">
            <div className="bg-accenta">
              <div className={`${getCssFor("block-div")}`}>
                <p className={`${getCssFor("title")} text-accent`}>Šířka</p>
                <div className="flex flex-row items-center">
                  <div className={`${getCssFor("btn-text-left")}  text-primary`}>{imageW}</div>
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="+"
                    onClick={() => plus(W)}
                    showIcon={false}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="-"
                    onClick={() => minus(W)}
                    showIcon={false}
                  />
                  <Button
                    type="toggle"
                    forceBeepDisabled={true}
                    className={`${getCssFor("toggle-btn")} rounded-none`}
                    title="x10"
                    onToggleStateChange={setOnW}
                    toggleState={isOnW}
                  />
                </div>
              </div>
              <div className={`${getCssFor("block-div")}`}>
                <p className={`${getCssFor("title")} text-accent`}>Výška</p>
                <div className="flex flex-row items-center">
                  <div className={`${getCssFor("btn-text-left")}  text-primary`}>{imageH}</div>
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="+"
                    onClick={() => plus(H)}
                    showIcon={false}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="-"
                    onClick={() => minus(H)}
                    showIcon={false}
                  />
                  <Button
                    type="toggle"
                    forceBeepDisabled={true}
                    className={`${getCssFor("toggle-btn")} rounded-none`}
                    title="x10"
                    onToggleStateChange={setOnH}
                    toggleState={isOnH}
                  />
                </div>
              </div>
              <div className={`${getCssFor("block-div")}`}>
                <p className={`${getCssFor("title")} text-accent`}>Jas</p>
                <div className="flex flex-row items-center">
                  <div className={`${getCssFor("btn-text-left")}  text-primary`}>{imageBrightness}</div>
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="+"
                    onClick={() => plus(BRIGHTNESS)}
                    showIcon={false}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="-"
                    onClick={() => minus(BRIGHTNESS)}
                    showIcon={false}
                  />
                  <Button
                    type="toggle"
                    forceBeepDisabled={true}
                    className={`${getCssFor("toggle-btn")} rounded-none`}
                    title="x10"
                    onToggleStateChange={setOnB}
                    toggleState={isOnB}
                  />
                </div>
              </div>
              <div className={`${getCssFor("block-div")}`}>
                <p className={`${getCssFor("title")} text-accent`}>Kvalita</p>
                <div className="flex flex-row items-center">
                  <div className={`${getCssFor("btn-text-left")}  text-primary`}>{imageQuality}</div>
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="+"
                    onClick={() => plus(QUALITY)}
                    showIcon={false}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="-"
                    onClick={() => minus(QUALITY)}
                    showIcon={false}
                  />
                  <Button
                    type="toggle"
                    forceBeepDisabled={true}
                    className={`${getCssFor("toggle-btn")} rounded-none`}
                    title="x10"
                    onToggleStateChange={setOnQ}
                    toggleState={isOnQ}
                  />
                </div>
              </div>
              <div className={`${getCssFor("block-div")}`}>
                <p className={`${getCssFor("title")} text-accent`}>Rotace</p>
                <div className="flex flex-row items-center">
                  <div className={`${getCssFor("btn-text-left")}  text-primary`}>{imageRotation}</div>
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="+"
                    onClick={() => plus(ROTATION)}
                    showIcon={false}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="-"
                    onClick={() => minus(ROTATION)}
                    showIcon={false}
                  />
                </div>
              </div>
            </div>

            {/* prava strana */}
            <div className="">
              <div className={`${getCssFor("block-div")}`}>
                <p className={`${getCssFor("title")} text-accent text-right`}>Ze shora</p>
                <div className="flex flex-row items-center place-content-end">
                  <Button
                    type="toggle"
                    forceBeepDisabled={true}
                    className={`${getCssFor("toggle-btn-right")} rounded-none`}
                    title="x10"
                    onToggleStateChange={setOnX}
                    toggleState={isOnX}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="+"
                    onClick={() => plus(X)}
                    showIcon={false}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="-"
                    onClick={() => minus(X)}
                    showIcon={false}
                  />
                  <div className={`${getCssFor("btn-text-right")} text-primary`}>{imageX}</div>
                </div>
              </div>
              <div className={`${getCssFor("block-div")}`}>
                <p className={`${getCssFor("title")} text-accent text-right`}>Z leva</p>
                <div className="flex flex-row items-center place-content-end">
                  <Button
                    type="toggle"
                    forceBeepDisabled={true}
                    className={`${getCssFor("toggle-btn-right")} rounded-none`}
                    title="x10"
                    onToggleStateChange={setOnY}
                    toggleState={isOnY}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="+"
                    onClick={() => plus(Y)}
                    showIcon={false}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="-"
                    onClick={() => minus(Y)}
                    showIcon={false}
                  />
                  <div className={`${getCssFor("btn-text-right")} text-primary`}>{imageY}</div>
                </div>
              </div>
              <div className={`${getCssFor("block-div")}`}>
                <p className={`${getCssFor("title")} text-accent text-right`}>Velikost X %</p>
                <div className="flex flex-row items-center place-content-end">
                  <Button
                    type="toggle"
                    forceBeepDisabled={true}
                    className={`${getCssFor("toggle-btn-right")} rounded-none`}
                    title="x10"
                    onToggleStateChange={setOnSX}
                    toggleState={isOnSX}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="+"
                    onClick={() => plus(SIZE_X)}
                    showIcon={false}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="-"
                    onClick={() => minus(SIZE_X)}
                    showIcon={false}
                  />
                  <div className={`${getCssFor("btn-text-right")} text-primary`}>{imageSizeX}</div>
                </div>
              </div>

              <div className={`${getCssFor("block-div")}`}>
                <p className={`${getCssFor("title")} text-accent text-right`}>Velikost Y %</p>
                <div className="flex flex-row items-center  place-content-end">
                  <Button
                    type="toggle"
                    forceBeepDisabled={true}
                    className={`${getCssFor("toggle-btn-right")} rounded-none`}
                    title="x10"
                    onToggleStateChange={setOnSY}
                    toggleState={isOnSY}
                  />

                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="+"
                    onClick={() => plus(SIZE_Y)}
                    showIcon={false}
                  />
                  <Button
                    type="terminal-dark"
                    forceBeepDisabled={true}
                    className={`${getCssFor("pm-btn")} rounded-none`}
                    title="-"
                    onClick={() => minus(SIZE_Y)}
                    showIcon={false}
                  />
                  <div className={`${getCssFor("btn-text-right")} text-primary`}>{imageSizeY}</div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className={`w-full grid ${bottomGridCss} absolute ${getCssFor("bottom-btn-grid")} left-0 place-items-center`}>
          {showButtons && (
            <Button
              type="terminal-dark"
              title="Uložit do API"
              showIcon={false}
              onClick={async () => await postCameraOptionsToApi()}
              className={`${getCssFor("bottom-btn")} rounded-none`}
            />
          )}
          {showHideButton && (
            <Button
              type="terminal-dark"
              title={showHideButtonsText}
              showIcon={false}
              onClick={() => setVisible(!isVisible)}
              className={`${getCssFor("bottom-btn")} rounded-none`}
            />
          )}
          {showButtons && (
            <Button
              type="terminal-dark"
              title="Test Foto"
              forceBeepDisabled={true}
              showIcon={false}
              onClick={async () => await runCapture()}
              className={`${getCssFor("bottom-btn")} rounded-none`}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default PageCameraTest;
